export const getSearchUrl = (locale: string, query: string, siteFilter?: string): string => {
    if (siteFilter && siteFilter !== "") {
        return `/${locale}/services/search/?q=${query}&origin=searchbar&site=${encodeURIComponent(siteFilter)}`;
    }
    return `/${locale}/services/search/?q=${query}&origin=searchbar`;
};
